import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import QuestionPrompt from '../QuestionPrompt';//eslint-disable-line import/no-named-as-default
import DialogPrompt from '../DialogPrompt';
import Option from './MultipleAnswerOption';
import Button from '../../../buttons/Button';//eslint-disable-line import/no-named-as-default
import Feedback from './MultipleAnswerFeedback';
import Conversation from '../../conversationDialog/ChildConversationDialog';
import BadgeCollect from '../../badges/BadgeCollect';
import * as appDataActions from '../../../../actions/appDataActions';
import * as trackingDataActions from '../../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../../actions/dialogPopupActions';
import * as appHelper from '../../../../helpers/appHelper';
import * as dataHelper from '../../../../helpers/dataHelper';
import * as kpiHelper from '../../../../helpers/kpiHelper';
import * as userDataHelper from '../../../../helpers/userDataHelper';
import * as xAPIHelper from '../../../../helpers/xAPIHelper';
import * as indicatorHelper from '../../../../helpers/indicatorHelper';
import * as objectConstants from '../../../../constants/objectConstants';
import * as appConstants from '../../../../constants/appConstants';
import * as localStorage from '../../../../localStorage/localStorage';
import * as keyboardConstants from '../../../../constants/keyboardConstants';
import * as componentConstants from '../../../../constants/componentConstants';
import * as animationHelper from '../../../../helpers/animationHelper';
import {MULTIPLE_ANSWER_REVIEW_CONFIG} from '../../../../models/dialogModels';

class MultipleAnswer extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screenObject: this.props.screenObject,
            userData: this.props.userData,
            locale: appHelper.getLocalData(this.props.screenObject),
            options: this.props.screenObject.options,
            reviewMode: false,
            propsUpdated: false,
            questionChecked: false,
            currentlyChecked: false,
            correctAnswerCount: appHelper.getTypeCount(this.props.screenObject.options, "result", "best").length,
            responseData: {
                bite_id: this.props.callbacks.getBiteId(),
                screen_id: this.props.callbacks.getScreenId(),
                asset_id: this.props.screenObject.asset_id,
                currentAttempt: 1,
                currentStatus: objectConstants.STATUS_NOT_STARTED,
                displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL,
                outcome: {},
                responses: [],
                checkedOptions: [],
                userSelections: [],
                latestResponse: {},
                initialised: false,
                scoring_type: this.props.screenObject.scoring_type
            },
            showOptions: false,
            enableCheckBtn: false,
            showCheckBtn: true,
            showFeedback: false,
            skipFeedback: false,
            showResponse: false,
            revealedOptions: [],
            watchCheckBtnState: true,
            screenStatus: "",
            checkObjectStatus: false,
            handleCompletion: false,
            progressionHandled: false,
            checkPostXAPIResponse: false,
            checkedForMissedOptions: false,
            missedOptions: {
                show: false,
                options: []
            },
            character_name: appHelper.isDefined(this.props.callbacks) ? this.props.callbacks.getCharacterName() : appHelper.getScreenCharacterNameByAssetId(this.props.screenObject.asset_id),
            focusOnFeedback: false,
            showProgression: false,
            hideFeedback: false,
            progression_label: "",
            hasBadges: false,
            badgesCollected: false,
            animateBadge: true,
            allowShowFeedback: true,
            multiple_choice_question_label: appHelper.getLocaleString("multiple_choice_question_label"),
            submit_label: appHelper.getLocaleString("submit_label"),
            continue_label: appHelper.getLocaleString("continue_label"),
            try_again_label: appHelper.getLocaleString("try_again_label"),
            missed_options_label: appHelper.getLocaleString("missed_options_label"),
            xApiResponseObj: {},
            usePreviousUserObjectData: true,
            animatePrompt: false,
        };

        this.randomiseOptions = this.randomiseOptions.bind(this);
        this.renderOptions = this.renderOptions.bind(this);
        this.onOptionClick = this.onOptionClick.bind(this);
        this.checkAnswers = this.checkAnswers.bind(this);
        this.showFeedback = this.showFeedback.bind(this);
        this.handleResponse = this.handleResponse.bind(this);
        this.handleProgression = this.handleProgression.bind(this);
        this.reattempt = this.reattempt.bind(this);
        this.onReviewObject = this.onReviewObject.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.setReviewMode = this.setReviewMode.bind(this);
        this.onOptionRevealed = this.onOptionRevealed.bind(this);
        this.setCheckBtnState = this.setCheckBtnState.bind(this);
        this.handleResponseComplete = this.handleResponseComplete.bind(this);
        this.postXAPIResponse = this.postXAPIResponse.bind(this);
        this.getStatusClass = this.getStatusClass.bind(this);
        this.onPanelClick = this.onPanelClick.bind(this);
        this.getMissedOptions = this.getMissedOptions.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.getTabIndex = this.getTabIndex.bind(this);
        this.onKeyboardPanelClick = this.onKeyboardPanelClick.bind(this);
        this.onFocusOnFeedback = this.onFocusOnFeedback.bind(this);
        this.handleSkipFeedback = this.handleSkipFeedback.bind(this);
        this.hasFeedbackToShow = this.hasFeedbackToShow.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.onProgressionClicked = this.onProgressionClicked.bind(this);
        this.onBadgeCollected = this.onBadgeCollected.bind(this);
        this.checkResponses = this.checkResponses.bind(this);
        this.showOutcome = this.showOutcome.bind(this);

        this.show = this.show.bind(this);

        this.question = React.createRef();
    }

    componentDidMount() {
        this.randomiseOptions();
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            this.checkResponses();
        } else {
            this.getObjectStatus();
        }

        this.show();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userData !== nextProps.userData) {
            this.setState({
                userData: Object.assign({}, nextProps.userData),
                checkObjectStatus: true
            });
        }

        if (this.state.lang !== nextProps.lang) {
            let progression_label = "";
            if (this.state.progression_label === this.state.try_again_label) {
                progression_label = appHelper.getLocaleString("try_again_label");
            } else if (this.state.progression_label === this.state.continue_label) {
                progression_label = appHelper.getLocaleString("continue_label");
            }
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                multiple_choice_question_label: appHelper.getLocaleString("multiple_choice_question_label"),
                submit_label: appHelper.getLocaleString("submit_label"),
                progression_label: progression_label,
                continue_label: appHelper.getLocaleString("continue_label"),
                try_again_label: appHelper.getLocaleString("try_again_label"),
                missed_options_label: appHelper.getLocaleString("missed_options_label"),
                checkedForMissedOptions: true
            });
        }
    }

    componentDidUpdate() {
        if (this.state.propsUpdated && this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
            this.setReviewMode();
        }

        if (this.state.watchCheckBtnState && !this.props.callbacks.isReviewMode()) {
            //console.log(`${this.state.revealedOptions.length} >= ${this.props.screenObject.options.length}`)
            this.setCheckBtnState(this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW);
        }

        if (this.state.skipFeedback) {
            this.handleSkipFeedback();
        }

        if (this.state.checkObjectStatus) {
            this.getObjectStatus();
        }

        if (this.state.handleCompletion && !this.state.progressionHandled) {
            this.handleProgression();
        }

        if (this.state.checkPostXAPIResponse) {
            this.postXAPIResponse();
        }

        if (this.state.checkedForMissedOptions) {
            this.getMissedOptions();
        }

        if (this.state.skipFeedback) {
            this.handleSkipFeedback();
        }

        if (this.state.focusOnFeedback) {
            this.onFocusOnFeedback();
        }
    }

    show() {
        let question = this.question.current;
        if(appHelper.isDefined(question) && question !== null) {
            let params = {
                ele: question,
                duration: objectConstants.QUESTION_DURATION,
                delay: 0,
                callback: null
            };
            animationHelper.showHeight(params);
        }
    }

    onFocusOnFeedback() {
        let focusEl = document.getElementById(`feedback_wrapper_${this.state.screenObject.asset_id}`);
        if (appHelper.isDefined(focusEl) && focusEl !== null) {
            focusEl.focus();
        }
        this.setState({focusOnFeedback: false});
    }

    postXAPIResponse() {
        this.setState({checkPostXAPIResponse: false});
        let interactionData = xAPIHelper.setMultiAnswerChoiceInteractionData(this.state.screenObject, this.state.responseData);
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {

            let screen = appHelper.getScreenByAssetId(this.state.screenObject.asset_id);
            let category = {
                constant: componentConstants.MULTIPLE_ANSWER,
                label: componentConstants.MULTIPLE_CHOICE_MULTIPLE_ANSWER_LABEL
            };

            this.props.actions.postActvityStatement(screen, interactionData, category);
        }
    }

    handleSkipFeedback() {
        let selectedOptions = [];
        for (let i = 0; i < this.state.responseData.checkedOptions.length; i++) {
            let selectedOption = this.state.responseData.checkedOptions[i];
            selectedOptions = dataHelper.immutablePush(selectedOptions, selectedOption.option_id);
        }

        let responseObj = {
            asset_id: this.state.screenObject.asset_id,
            selectedOptions: selectedOptions,
            kpis: !appHelper.isDefined(this.state.responseData.outcome.kpis) || this.state.responseData.outcome.kpis !== null ? this.state.responseData.outcome.kpis : [],
            indicators: appHelper.isDefined(this.state.responseData.outcome.indicators) && this.state.responseData.outcome.indicators !== null ? this.state.responseData.outcome.indicators : [],
        };

        this.setState({skipFeedback: false});
        //console.log(responseObj);
        //console.log(this.props.callbacks);
        this.props.callbacks.storeUserResponse(responseObj);

        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.responseData.outcome.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.responseData.outcome.character_pose);
        }

        if (!this.state.hasBadges) {
            let handleResponse = this.handleResponse;

            setTimeout(function () {
                handleResponse();
            }, 1000);
        }
    }

    setCheckBtnState(state) {
        if (this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
            this.setState({showCheckBtn: state, watchCheckBtnState: false});
        }
    }

    //options functions

    randomiseOptions() {
        if (this.state.screenObject.randomise_options) {
            this.setState({
                options: dataHelper.randomiseArray(this.state.options),
                showOptions: true
            });
        } else {
            this.setState({showOptions: true});
        }
        this.props.callbacks.scrollToTop();
    }


    renderOptions() {
        if (!this.state.showOptions && this.state.responseData.currentStatus === objectConstants.STATUS_NOT_STARTED) {
            this.setState({showOptions: true});
        }

        this.props.callbacks.scrollToTop();
    }

    onOptionRevealed(option) {
        let index = appHelper.getArrayObjectIndexByKey(this.state.revealedOptions, "option_id", option.option_id);
        if (index === -1) {
            this.setState(
                {
                    revealedOptions: dataHelper.immutablePush(this.state.revealedOptions, option),
                    watchCheckBtnState: true
                }
            );
        }
    }

    onOptionClick(event) {
        let checkedOptions = Object.assign([], this.state.responseData.checkedOptions);
        let option = appHelper.getObjectOption(this.state.screenObject.options, event.target.value);
        let optionIndex = appHelper.getArrayObjectIndexByKey(checkedOptions, "option_id", option.option_id);
        if (optionIndex == -1) {
            checkedOptions = dataHelper.immutablePush(checkedOptions, option);
        } else {
            checkedOptions = dataHelper.immutableSplice(checkedOptions, optionIndex, 1);
        }
        //console.log(checkedOptions);
        this.setState({
            responseData: Object.assign({}, this.state.responseData,
                {
                    checkedOptions: Object.assign([], checkedOptions),
                    initialised: true
                }
            ),
            enableCheckBtn: checkedOptions.length > 0,

        });
    }

    //interaction control

    showOutcome() {
        return !this.state.screenObject.hide_outcome || (this.state.screenObject.hide_outcome && this.state.screenObject.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE);
    }

    checkAnswers() {
        let correctAnswers = appHelper.getTypeCount(this.state.responseData.checkedOptions, "result", "best");
        let incorrectAnswers = appHelper.getNotOfTypeCount(this.state.responseData.checkedOptions, "result", "best");
        let kpis = kpiHelper.averageKpis(this.state.responseData.checkedOptions);
        let indicators = indicatorHelper.getCheckedOptionIndicators(this.state.responseData.checkedOptions);
        let outcome = {};

        if (correctAnswers.length === this.state.correctAnswerCount && incorrectAnswers.length === 0) {
            outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "best"), {
                indicators: indicators
            });
        } else {
            if (correctAnswers.length > 0) {
                outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "ok"), {
                    indicators: indicators
                });
                if (!appHelper.isDefined(outcome.result)) {
                    outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "poor"), {
                        indicators: indicators
                    });
                }
            } else {
                outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "poor"), {
                    indicators: indicators
                });
            }
        }

        if (this.state.screenObject.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE) {
            outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "best"), {
                result: "reflective",
                indicators: indicators
            });
        }

        let showResponse = false;
        if (appHelper.isDefined(outcome.dialogs) && outcome.dialogs.length > 0) {
            showResponse = true;
        }


        let enable_feedback = outcome.enable_feedback && this.showOutcome();

        let hasBadges = appHelper.isDefined(outcome.badges) && outcome.badges.length > 0 && !enable_feedback && !showResponse;
        let progressionType = appHelper.isDefined(outcome.progression_type) ? outcome.progression_type : undefined;
        this.setState({
            responseData: Object.assign({}, this.state.responseData,
                {
                    outcome: outcome,
                    displayState: objectConstants.OBJECT_DISPLAY_STATE_ANSWERED,
                }
            ),
            showResponse: showResponse,
            showFeedback: enable_feedback && !showResponse,
            focusOnFeedback: enable_feedback && !showResponse,
            skipFeedback: !enable_feedback && outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && !showResponse,
            //showProgression: !enable_feedback && outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN  && !showResponse,
            showProgression: (!enable_feedback && outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) || ( !enable_feedback && outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && !this.props.callbacks.hasNextObject(this.props.index) && progressionType !== objectConstants.GO_TO_TYPE_SCREEN) && !showResponse && !hasBadges,

            progression_label: outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
            hasBadges: hasBadges,
            questionChecked: true,
            currentlyChecked: true,
            showCheckBtn: false,
            enableCheckBtn: false,
            showOptions: true,
            initialised: false,
            checkPostXAPIResponse: true,
            checkedForMissedOptions: true,

        });
    }

    handleResponse() {
        this.setState({hideFeedback: false});
        let progressionRule = this.state.responseData.outcome.progression;

        let showResponse = false;
        if (appHelper.isDefined(this.state.responseData.outcome.dialogs) && this.state.responseData.outcome.dialogs.length > 0) {
            showResponse = true;
        }


        if (progressionRule === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
            this.reattempt();
        } else {
            let show_feedback_after_completion = this.state.responseData.outcome.feedback_settings.show_feedback_after_completion;
            let showFeedbackOnceComplete = this.state.showFeedback && show_feedback_after_completion && this.state.responseData.outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && this.hasFeedbackToShow();
            this.setState(
                {
                    showFeedback: showFeedbackOnceComplete || (!this.props.callbacks.hasNextObject(this.props.index) && this.hasFeedbackToShow()),
                    focusOnFeedback: showFeedbackOnceComplete || (!this.props.callbacks.hasNextObject(this.props.index) && this.hasFeedbackToShow()),
                    showOptions: true,
                    options: Object.assign([], this.state.responseData.checkedOptions),
                    responseData: Object.assign(
                        {}, this.state.responseData,
                        {
                            currentStatus: objectConstants.STATUS_COMPLETE,
                            displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                        }
                    ),
                    handleCompletion: true,
                }
            );
        }
    }

    hasFeedbackToShow() {
        let enable_feedback = this.state.responseData.outcome.enable_feedback && this.showOutcome();

        return enable_feedback;
    }

    handleProgression() {
        let enable_feedback = this.state.responseData.outcome.enable_feedback && this.showOutcome();

        let progressionRule = appHelper.isDefined(this.state.responseData.outcome.progression) ? this.state.responseData.outcome.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
        let progressionType = appHelper.isDefined(this.state.responseData.outcome.progression_type) ? this.state.responseData.outcome.progression_type : undefined;
        let progressionGoToId = appHelper.isDefined(this.state.responseData.outcome.progression_goto_id) ? this.state.responseData.outcome.progression_goto_id : undefined;
        this.setState({handleCompletion: false, progressionHandled: true});
        let completionData = {
            progression: progressionRule,
            asset_id: this.state.screenObject.asset_id,
            status: objectConstants.STATUS_COMPLETE,
            asset_type_code: this.state.screenObject.asset_type_code,
            //navigateToNextScreen: enable_feedback && progressionType !== objectConstants.GO_TO_TYPE_SCREEN,
            navigateToNextScreen: progressionType !== objectConstants.GO_TO_TYPE_SCREEN,
            progressionType: progressionType,
            progressionGoToId: progressionGoToId,
            index: this.props.index,
            showProgression: this.state.showProgression,
        };

        this.props.callbacks.onObjectComplete(completionData);
    }

    showFeedback() {
        if (this.state.responseData.currentStatus !== objectConstants.STATUS_COMPLETE) {
            this.setState({showFeedback: true, focusOnFeedback: true});
        }
    }

    checkResponses() {
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            let parentScreen = this.props.callbacks.getSubScreenParent();
            let params = {

                bite_id: this.props.callbacks.getBiteId(),
                screen_id: this.props.callbacks.getScreenId(),
                parent_screen_id: appHelper.isDefined(parentScreen) ? parentScreen.screen_id : undefined,
                asset_id: this.state.screenObject.asset_id,
            };

            let interactionData = xAPIHelper.getMultipleChoiceIds(params);

            this.props.actions.getActvityStatement(interactionData).then((responseObj) => {
                if (appHelper.isDefined(responseObj.statement) && appHelper.isDefined(responseObj.statement.result.completion)) {
                    this.setState({
                        xApiResponseObj: Object.assign({}, responseObj),
                        reviewMode: true,
                        propsUpdated: true,
                        responseData: Object.assign(
                            {}, this.state.responseData,
                            {
                                currentStatus: objectConstants.STATUS_COMPLETE,
                                displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                            }
                        )
                    });
                }
            });
        }
    }

    getObjectStatus() {
        this.setState({checkObjectStatus: false});
        if (this.state.responseData.currentStatus !== objectConstants.STATUS_COMPLETE && this.state.usePreviousUserObjectData) {
            let screenStatus = userDataHelper.getObjectStatus(this.state.userData, this.props.screenObject.asset_id);
            if (screenStatus === objectConstants.STATUS_COMPLETE && this.state.screenObject.attempt_type === objectConstants.ATTEMPT_TYPE_FIRST) {
                this.setState({
                    reviewMode: true,
                    propsUpdated: true,
                    responseData: Object.assign(
                        {}, this.state.responseData,
                        {
                            currentStatus: objectConstants.STATUS_COMPLETE,
                            displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                        }
                    )
                });
            } else {
                let objectUserData = {};
                if (this.state.status !== objectConstants.STATUS_COMPLETE) {
                    let subScreenParent = this.props.callbacks.getSubScreenParent();
                    let screen_id = this.props.callbacks.getScreenId();
                    if (appHelper.isDefined(subScreenParent)) {
                        objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
                    } else {
                        objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
                    }
                }

                if (objectUserData.status === objectConstants.STATUS_COMPLETE && this.state.screenObject.attempt_type === objectConstants.ATTEMPT_TYPE_FIRST) {
                    this.setState({
                        reviewMode: true,
                        propsUpdated: true,
                        responseData: Object.assign(
                            {}, this.state.responseData,
                            {
                                currentStatus: objectConstants.STATUS_COMPLETE,
                                displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                            }
                        )
                    });
                }
            }
        }
    }

    setReviewMode() {
        let optionIds = appHelper.getObjectOptionIds(this.state.screenObject);
        let kpiUserData = userDataHelper.getUserResponseByOptionIds(this.state.userData, this.props.callbacks.getBiteId(), optionIds);
        let showResponse = false;

        if (appHelper.isDefined(kpiUserData)) {
            let checkedOptions = appHelper.getObjectCheckedOptionsByKpiHistoryOptions(kpiUserData.option_id);
            let outcome = appHelper.getObjectOutcomeByKpiHistoryOptions(kpiUserData.option_id);
            if (appHelper.isDefined(outcome.dialogs) && outcome.dialogs.length > 0) {
                showResponse = true;
            }
            let responseData = Object.assign({}, this.state.responseData, {
                checkedOptions: checkedOptions,
                outcome: outcome
            });

            let enable_feedback = outcome.enable_feedback && this.showOutcome();
            let show_feedback_after_completion = outcome.feedback_settings.show_feedback_after_completion && this.showOutcome();
            let hasBadges = appHelper.isDefined(outcome.badges) && outcome.badges.length > 0 && this.showOutcome();
            this.setState(
                {
                    showProgression: !this.props.callbacks.hasNextObject(this.props.index) && enable_feedback && (!hasBadges || hasBadges && this.state.badgesCollected),
                    hasBadges: hasBadges,
                    badgesCollected: this.state.badgesCollected,
                    showFeedback: enable_feedback && show_feedback_after_completion,
                    handleCompletion: true,
                    showResponse: showResponse,
                    progression_label: outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
                    propsUpdated: false,
                    showOptions: true,
                    options: Object.assign([], checkedOptions),
                    showCheckBtn: false,
                    responseData: responseData,
                    checkedForMissedOptions: true,
                    allowShowFeedback: enable_feedback && show_feedback_after_completion,
                }
            );
        } else if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            let responseObj = Object.assign({}, this.state.xApiResponseObj);
            if (appHelper.isDefined(responseObj.statement)) {
                let responseString = responseObj.statement.result.response;
                let choices = responseObj.statement.object.definition.choices;
                let responseArray = responseString.split("[,]");
                let selectedOptions = [];

                for (let i = 0; i < responseArray.length; i++) {
                    let responseString = responseArray[i];
                    //let optionResponse = xAPIHelper.getChoiceByDescription(choices,responseString);
                    let optionResponse = xAPIHelper.getChoiceById(choices, responseString);
                    if (appHelper.isDefined(optionResponse.id)) {
                        let optionDetails = appHelper.getOptionParentDetails(parseInt(optionResponse.id));
                        if (appHelper.isDefined(optionDetails.option.option_id)) {
                            selectedOptions = dataHelper.immutablePush(selectedOptions, optionDetails.option);
                        }
                    }
                }

                if (selectedOptions.length > 0) {


                    let correctAnswers = appHelper.getTypeCount(selectedOptions, "result", "best");
                    let incorrectAnswers = appHelper.getNotOfTypeCount(selectedOptions, "result", "best");
                    let kpis = kpiHelper.averageKpis(selectedOptions);
                    let outcome = {};
                    if (correctAnswers.length === this.state.correctAnswerCount && incorrectAnswers.length === 0) {
                        outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "best"), {
                            kpis: kpis
                        });
                    } else {
                        if (correctAnswers.length > 0) {
                            outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "ok"), {
                                kpis: kpis
                            });
                            if (!appHelper.isDefined(outcome.result)) {
                                outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "poor"), {
                                    kpis: kpis
                                });
                            }
                        } else {
                            outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "poor"), {
                                kpis: kpis
                            });
                        }
                    }

                    if (this.state.screenObject.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE) {
                        outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "best"), {
                            kpis: kpis,
                            result: "reflective"
                        });
                    }

                    if (appHelper.isDefined(outcome.dialogs) && outcome.dialogs.length > 0) {
                        showResponse = true;
                    }
                    let responseData = Object.assign({}, this.state.responseData, {
                        checkedOptions: selectedOptions,
                        outcome: outcome
                    });

                    let enable_feedback = outcome.enable_feedback && this.showOutcome();
                    let show_feedback_after_completion = outcome.feedback_settings.show_feedback_after_completion && this.showOutcome();

                    let hasBadges = appHelper.isDefined(outcome.badges) && outcome.badges.length > 0 && this.showOutcome();
                    this.setState(
                        {
                            showProgression: !this.props.callbacks.hasNextObject(this.props.index) && enable_feedback && (!hasBadges || hasBadges && this.state.badgesCollected),
                            hasBadges: hasBadges,
                            badgesCollected: this.state.badgesCollected,
                            handleCompletion: true,
                            showFeedback: enable_feedback && show_feedback_after_completion,
                            showResponse: showResponse,
                            progression_label: outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
                            propsUpdated: false,
                            showOptions: true,
                            options: Object.assign([], selectedOptions),
                            showCheckBtn: false,
                            responseData: responseData,
                            checkedForMissedOptions: true,
                            allowShowFeedback: enable_feedback && show_feedback_after_completion,
                        }
                    );
                } else {
                    this.setState({
                        reviewMode: false,
                        propsUpdated: false,
                        usePreviousUserObjectData: false,
                        responseData: Object.assign(
                            {}, this.state.responseData,
                            {
                                currentStatus: objectConstants.STATUS_NOT_STARTED,
                                displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL,
                            }
                        )
                    });
                }

            } else {
                this.setState({propsUpdated: false, usePreviousUserObjectData: false,});
            }
        } else {
            this.setState({
                reviewMode: false,
                propsUpdated: false,
                usePreviousUserObjectData: false,
                responseData: Object.assign(
                    {}, this.state.responseData,
                    {
                        currentStatus: objectConstants.STATUS_NOT_STARTED,
                        displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL,
                    }
                )
            });
        }
    }

    reattempt() {
        let focusEl = this.refs[`${this.state.screenObject.asset_id}_questionOptions`];
        focusEl.focus();
        let correctAnswers = appHelper.getTypeCount(this.state.responseData.checkedOptions, "correct", true);
        this.setState(
            {
                showFeedback: false,
                hideFeedback: false,
                showCheckBtn: true,
                revealedOptions: dataHelper.immutableSplice(this.state.revealedOptions, 0, this.state.revealedOptions.length),
                enableCheckBtn: correctAnswers.length > 0,
                showOptions: true,
                showResponse: false,
                currentlyChecked: false,
                responseData: Object.assign(
                    {}, this.state.responseData,
                    {
                        currentAttempt: this.state.responseData.currentAttempt + 1,
                        currentStatus: objectConstants.STATUS_ATTEMPTED,
                        displayState: objectConstants.OBJECT_DISPLAY_STATE_RETRY,
                        outcome: Object.assign({}, {}),
                        checkedOptions: Object.assign([], correctAnswers)

                    }
                )
            }
        );
    }

    onReviewObject(sourceId) {
        if (this.hasFeedbackToShow()) {
            let config = Object.assign({}, MULTIPLE_ANSWER_REVIEW_CONFIG,
                {
                    title: this.state.locale.label,
                    sourceId: sourceId
                }
            );
            //locale.title


            for (let i = 0; i < config.childComponents.length; i++) {
                let child = config.childComponents[i];
                child.componentProps = Object.assign({}, {
                    screenObject: this.state.screenObject,
                    responseData: Object.assign(
                        {}, this.state.responseData,
                        {
                            displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                            userSelections: Object.assign([], this.state.responseData.checkedOptions)
                        }
                    ),
                    callbacks: this.props.callbacks
                });
            }
            this.props.actions.setNewDialog(config);
        }
    }

    handleResponseComplete() {
        let outcome = this.state.responseData.outcome;
        let enable_feedback = outcome.enable_feedback && this.showOutcome();

        let progressionType = appHelper.isDefined(outcome.progression_type) ? outcome.progression_type : undefined;

        this.setState(
            {
                showFeedback: enable_feedback && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                focusOnFeedback: enable_feedback && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                hasBadges: appHelper.isDefined(this.state.responseData.outcome.badges) && this.state.responseData.outcome.badges.length > 0 && !enable_feedback,
                skipFeedback: !enable_feedback && this.state.responseData.outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN,
                //showProgression: !enable_feedback &&  this.state.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN,
                showProgression: (!enable_feedback && outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) || ( !enable_feedback && outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && !this.props.callbacks.hasNextObject(this.props.index) && progressionType !== objectConstants.GO_TO_TYPE_SCREEN) || this.state.showProgression,
            }
        );
    }

    getStatusClass() {
        return this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && appHelper.isDefined(this.state.responseData.outcome.feedback_settings) && this.state.responseData.outcome.feedback_settings.include_explore_feedback && this.hasFeedbackToShow() ? "complete" : "";
    }

    getTabIndex() {
        return this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && appHelper.isDefined(this.state.responseData.outcome.feedback_settings) && this.state.responseData.outcome.feedback_settings.include_explore_feedback ? 0 : -1;
    }

    onPanelClick() {

        if (this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && appHelper.isDefined(this.state.responseData.outcome.feedback_settings) && this.state.responseData.outcome.feedback_settings.include_explore_feedback && this.hasFeedbackToShow()) {
            this.onReviewObject(`question_wrapper_${this.state.screenObject.asset_id}`);
        }
    }

    onKeyboardPanelClick(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            if (this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && appHelper.isDefined(this.state.responseData.outcome.feedback_settings) && this.state.responseData.outcome.feedback_settings.include_explore_feedback) {
                this.onReviewObject(`question_wrapper_${this.state.screenObject.asset_id}`);
            }
        }
    }

    getMissedOptions() {
        this.setState({checkedForMissedOptions: false});
        let missedOptions = [];
        for (let o = 0; o < this.state.screenObject.options.length; o++) {
            let option = this.state.screenObject.options[o];
            let locale = appHelper.getLocalData(option);
            let optionCheckedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions, "option_id", option.option_id);
            let optionObject = {
                result: option.result,
                className: optionCheckedIndex > -1 ? 'checked' : 'missed',
                option_text: locale.option,
                option_id: option.option_id
            };
            if (optionCheckedIndex === -1 && this.state.responseData.outcome.result !== objectConstants.RESULT_BEST && option.result === objectConstants.RESULT_BEST && this.state.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE) {
                missedOptions = dataHelper.immutablePush(missedOptions, optionObject);
            }
        }
        if (missedOptions.length > 0) {
            this.setState({
                missedOptions: Object.assign({}, this.state.missedOptions, {
                    show: true,
                    options: Object.assign([], missedOptions)
                })
            });
        }
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    enableProgression(progression_label) {
        let hasBadges = appHelper.isDefined(this.state.responseData.outcome.badges) && this.state.responseData.outcome.badges.length > 0 && this.showOutcome();
        let progressionType = appHelper.isDefined(this.state.responseData.outcome.progression_type) ? this.state.responseData.outcome.progression_type : undefined;
        let showProgression = (!hasBadges || this.state.showProgression);
        if (!this.props.callbacks.hasNextObject(this.props.index)) {
            showProgression = ((!hasBadges || hasBadges && this.state.badgesCollected) || this.state.showProgression) && progressionType !== objectConstants.GO_TO_TYPE_SCREEN && this.state.responseData.outcome.progression !== objectConstants.OBJECT_PROGRESSION_TERMINAL;
        }
        this.setState({
            showProgression: showProgression,
            hasBadges: hasBadges,
            progression_label: this.state.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
        });
        this.props.callbacks.scrollToContinue();
    }

    onProgressionClicked() {
        let show_feedback_after_completion = this.state.responseData.outcome.feedback_settings.show_feedback_after_completion && this.showOutcome();
        let showFeedbackOnceComplete = show_feedback_after_completion && this.state.responseData.outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN;
        let hideFeedback = !showFeedbackOnceComplete && (this.props.callbacks.hasNextObject(this.props.index) && this.state.responseData.outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN);

        this.setState({
            showProgression: false,
            hideFeedback: hideFeedback,

        });


        let enable_feedback = this.state.responseData.outcome.enable_feedback;

        if (!this.props.callbacks.hasNextObject(this.props.index) && this.state.responseData.outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
            this.props.callbacks.navigateToNextScreen();
        } else if (this.props.callbacks.hasNextObject(this.props.index) && !hideFeedback) {
            this.handleResponse();
        } else if (this.state.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
            this.reattempt();
        }
    }

    onBadgeCollected() {
        let show_feedback_after_completion = this.state.responseData.outcome.feedback_settings.show_feedback_after_completion && this.showOutcome();
        let showFeedbackOnceComplete = this.state.showFeedback && show_feedback_after_completion && this.state.responseData.outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN;
        this.setState({badgesCollected: true, showFeedback: showFeedbackOnceComplete});
        if (!this.props.callbacks.hasNextObject(this.props.index)) {
            this.setState({
                showProgression: true,
                progression_label: this.state.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
            });
            this.props.callbacks.scrollToContinue();
        }

        this.handleResponse();

    }

    render() {
        return (
            <div className="a-c" ref={this.question}>
                <div className="learner-action">
                    <p className="hidden-el">{this.state.multiple_choice_question_label}</p>
                    {
                        appHelper.isDefined(this.props.characterPose) && appHelper.isDefined(this.props.characterPose.src) && this.props.characterPose.src.length > 0
                            ?
                            <div className={`content-character-expression`}>
                                <img src={this.getImagePath(this.props.characterPose.src)} alt=""/>
                            </div>
                            :
                            null
                    }
                    <div className={`question-wrapper ${this.getStatusClass()}`} tabIndex={this.getTabIndex()}
                         id={`question_wrapper_${this.state.screenObject.asset_id}`}
                         role="presentation" onClick={this.onPanelClick} onKeyDown={this.onKeyboardPanelClick}>
                        {
                            this.state.screenObject.prompt_type !== objectConstants.PROMPT_TYPE_SHOW_NO_PROMPT && this.state.screenObject.show_prompt
                                ?
                                this.state.screenObject.prompt_settings.class_name === objectConstants.DIALOG
                                    ?

                                    <div className="object-container">
                                        <DialogPrompt character_name={this.state.character_name}
                                                      screenObject={this.state.screenObject}
                                                      onComplete={this.onPromptRevealed}
                                                      animatePrompt={this.state.animatePrompt}
                                        />
                                    </div>
                                    :
                                    <QuestionPrompt
                                        screenObject={this.state.screenObject}
                                        onComplete={this.onPromptRevealed}
                                        animatePrompt={this.state.animatePrompt}
                                    />
                                :
                                null
                        }

                        {this.state.showOptions
                            ?
                            <div className="multiple-choice-option-list theme-active"
                                 id={`${this.state.screenObject.asset_id}_questionOptions`}
                                 ref={`${this.state.screenObject.asset_id}_questionOptions`}
                            >
                                {this.state.options.map(option =>
                                    <Option key={`option_${option.option_id}`}
                                            option={option}
                                            asset_id={this.state.screenObject.asset_id}
                                            questionChecked={this.state.questionChecked}
                                            currentlyChecked={this.state.currentlyChecked}
                                            onOptionClick={this.onOptionClick}
                                            responseData={this.state.responseData}
                                            onAttemptComplete={this.showFeedback}
                                            onOptionRevealed={this.onOptionRevealed}
                                            onShowReview={this.onReviewObject}
                                            index={appHelper.getObjectOptionIndex(this.state.screenObject.options, option.option_id)}
                                            callbacks={this.props.callbacks}
                                            showOutcome={this.showOutcome()}
                                    />
                                )}
                            </div>
                            :
                            null
                        }


                        {this.state.missedOptions.show && this.showOutcome()
                            ?
                            <div className="object-container">
                                <div className="missed-options">
                                    <div className="missed-options-label"
                                         dangerouslySetInnerHTML={{__html: this.state.missed_options_label}}/>
                                    <ul className="multiple-choice-option-list">
                                        {this.state.missedOptions.options.map(missed_option =>
                                            <li className={`multiple-choice-option ${missed_option.className}`}
                                                key={`option_${missed_option.option_id}`}>
                                                <input id={this.state.id} name={this.state.id} type="checkbox"
                                                       disabled="disabled" tabIndex="-1" aria-disabled="true"
                                                       aria-checked="false"/>
                                                <label htmlFor={this.state.id}>
                                                    <span
                                                        dangerouslySetInnerHTML={{__html: missed_option.option_text}}/>
                                                </label>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                            :
                            null
                        }

                        {this.state.showCheckBtn
                            ? <Button label={this.state.submit_label}
                                      id={`${this.state.screenObject.asset_id}_check_button`}
                                      isDisabled={!this.state.enableCheckBtn}
                                      onRevealed={this.props.callbacks.scrollToTop}
                                      onClick={this.checkAnswers}/>
                            : null
                        }
                        {this.state.showResponse || this.state.showFeedback
                            ?
                            <div ref={`feedback_wrapper_${this.state.screenObject.asset_id}`}
                                 id={`feedback_wrapper_${this.state.screenObject.asset_id}`}
                                 role="article"
                                 tabIndex={0}
                                 className="feedback-focus">
                                {this.state.showResponse
                                    ?
                                    <Conversation asset_id={this.state.screenObject.asset_id}
                                                  option_id={this.state.responseData.outcome.option_id}
                                                  dialogs={this.state.responseData.outcome.dialogs}
                                                  callbacks={this.props.callbacks}
                                                  onComplete={this.handleResponseComplete}/>
                                    :
                                    null
                                }

                                {this.state.showFeedback && this.state.allowShowFeedback
                                    ? <Feedback screenObject={this.state.screenObject}
                                                options={this.state.screenObject.options}
                                                asset_id={this.state.screenObject.asset_id}
                                                responseData={this.state.responseData}
                                                onComplete={this.handleResponse}
                                                onShowReview={this.onReviewObject}
                                                onEnableProgression={this.enableProgression}
                                                hideFeedback={this.state.hideFeedback}
                                                callbacks={this.props.callbacks}
                                                index={this.props.index}
                                    />
                                    : null
                                }
                            </div>
                            :
                            null
                        }
                        {(this.state.showResponse || this.state.showFeedback) && this.state.hasBadges
                            ?
                            <br/>
                            :
                            null
                        }
                        {
                            this.state.hasBadges
                                ?
                                <div className="badge-wrapper">
                                    {this.state.responseData.outcome.badges.map(badge =>
                                        <BadgeCollect key={badge.badge_id} badge_id={badge.badge_id}
                                                      bite_id={this.props.callbacks.getBiteId()}
                                                      asset_id={this.state.screenObject.asset_id}
                                                      onCollected={this.onBadgeCollected}
                                                      animate={this.state.animateBadge}/>
                                    )}
                                </div>
                                : null
                        }
                    </div>
                    {this.state.showProgression
                        ?
                        <Button label={this.state.progression_label} id={`${this.state.screenObject.asset_id}_button`}
                                onClick={this.onProgressionClicked}/>
                        : null

                    }
                </div>
            </div>
        );
    }
}

MultipleAnswer.propTypes = {
    screenObject: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    characterPose: PropTypes.object,
    index: PropTypes.number,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

MultipleAnswer.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MultipleAnswer);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/multipleAnswer/MultipleAnswer.js
 **/